import { render, staticRenderFns } from "./cursos.vue?vue&type=template&id=4b47566b"
import script from "./cursos.vue?vue&type=script&lang=js"
export * from "./cursos.vue?vue&type=script&lang=js"
import style0 from "./cursos.vue?vue&type=style&index=0&id=4b47566b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports